import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { hasAnyRole } from "../utils/roles";

export default function ProtectedRoute({ allowedRoles }) {
  const { currentUser } = useAuth();

  // Still loading
  if (currentUser === undefined) return null;

  // Not logged in
  if (!currentUser) return <Navigate to="/login" replace />;

  // Must change password
  if (currentUser.mustChangePassword) {
    return <Navigate to="/change-password" replace />;
  }

  // Role not allowed
  if (allowedRoles && Array.isArray(allowedRoles) && !hasAnyRole(currentUser, allowedRoles)) {
    return <Navigate to="/" replace />;
  }

  // Allowed
  return <Outlet />;
}